import styled from 'styled-components';

import { Box } from 'components/Box';
import { Carousel, useCarouselState } from 'components/Carousel';
import { RichTextHeadline } from 'components/Text/RichTextHeadline';
import { useIsClient } from 'hooks/useIsClient';
import { CmsApiThreeSectionSliderBlockData } from 'modules/cms/api/types/blocks/CmsApiThreeSectionSliderBlock';
import { colors } from 'theme';

import { CmsThreeSectionSliderBlockCarouselNavigation } from './CmsThreeSectionSliderBlockCarouselNavigation';
import { CmsThreeSectionSliderBlockSection } from './CmsThreeSectionSliderBlockSection';
import { THREE_SECTION_SLIDER_BLOCK_IMAGE_SIZES } from './cmsThreeSectionSliderConstants';

const CarouselContainer = styled.div`
  position: relative;
  margin-top: 40px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    height: 100%;
    width: 2px;
    background: white;
  }
`;

type Props = {
  data: CmsApiThreeSectionSliderBlockData;
};

export function CmsThreeSectionSliderBlock({ data }: Props) {
  const { headline, imageSize, sections } = data;

  const withImages = sections.some((section) => section.image);

  const carouselState = useCarouselState({
    slideCount: sections.length,
    responsiveSlidesPerPage: { xs: 1, sm: 1, md: 2, lg: 3 },
  });

  const isClient = useIsClient();

  return (
    <>
      {headline && (
        <RichTextHeadline textAlignCenter>{headline}</RichTextHeadline>
      )}

      <CarouselContainer>
        <Carousel
          state={carouselState}
          data-qa-id="three-section-slider-carousel"
          height={THREE_SECTION_SLIDER_BLOCK_IMAGE_SIZES[imageSize] + 26}
          navigation={
            isClient && (
              <CmsThreeSectionSliderBlockCarouselNavigation
                carouselState={carouselState}
              />
            )
          }
          slides={sections.map((section, index) => (
            <Box
              height="100%"
              borderLeft={[
                null,
                null,
                index > 0 ? `1px solid ${colors.elementGrey}` : null,
              ]}
            >
              <CmsThreeSectionSliderBlockSection
                imageQaId="slider-image"
                text={section.content}
                image={section.image}
                imageSize={imageSize}
                withImages={withImages}
              />
            </Box>
          ))}
        />
      </CarouselContainer>
    </>
  );
}
